import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ObjectUtils } from 'primereact/utils';
import { LayoutContext } from './context/layoutcontext';

const AppBreadcrumb = () => {
    const location = useLocation();
    const [breadcrumb, setBreadcrumb] = useState(null);
    const { breadcrumbs } = useContext(LayoutContext);

    useEffect(() => {
        const filteredBreadcrumbs = breadcrumbs?.find((crumb) => {
            const lastPathSegment = crumb.to.split('/').pop();
            const lastRouterSegment = location.pathname.split('/').pop();

            if (lastRouterSegment?.startsWith('[') && !isNaN(Number(lastPathSegment))) {
                return location.pathname.split('/').slice(0, -1).join('/') === crumb.to?.split('/').slice(0, -1).join('/');
            }
            return crumb.to === location.pathname;
        });

        setBreadcrumb(filteredBreadcrumbs);
    }, [location, breadcrumbs]);

    return (
        <nav className="layout-breadcrumb">
            <ol>
                {ObjectUtils.isNotEmpty(breadcrumb)
                    ? breadcrumb.labels.map((label, index) => {
                          return (
                              <React.Fragment key={index}>
                                  {index !== 0 && <li className="layout-breadcrumb-chevron"> / </li>}
                                  <li key={index}>{label}</li>
                              </React.Fragment>
                          );
                      })
                    : null}
            </ol>
        </nav>
    );
};

export default AppBreadcrumb;